import React from "react";

import moment from "moment";

import { getAdminVerificationYearlyDataYear, useTranslation } from "utils";

import { AccessCard, Col, Progress, Row, TimelineStatusLabel, Typography } from "components";

export const TaskAccessCard = ({ farmTasks, onClick }) => {
  const { t } = useTranslation("tasks");

  const nearestDeadline = farmTasks.filter(({ completedAt }) => !completedAt).sort((a, b) => moment(a.deadline) - moment(b.deadline))[0]?.deadline;
  const daysToDeadline = nearestDeadline ? moment(nearestDeadline).diff(moment(), "days", true) : null;

  const completedTaskCount = farmTasks.filter(({ completedAt }) => completedAt).length;

  return (
    <AccessCard
      variant="actionable"
      onClick={onClick}
      mixpanelText="task-card"
      dataTestId={"task-access-card"}
      headline={t("taskAccessCard.headline", { year: getAdminVerificationYearlyDataYear() })}
      description={t("taskAccessCard.description")}
      contentTop={<TimelineStatusLabel status="noDeadline" daysLeft={Math.floor(daysToDeadline)} date={nearestDeadline} />}
      contentBottom={
        <Row className="margin-top-50">
          <Col className="padding-right-0">
            <div className="right">
              <Typography variant="paragraph-s" bold>
                {completedTaskCount}/{farmTasks.length}
              </Typography>
            </div>
            <Progress percent={(completedTaskCount / farmTasks.length) * 100} showInfo={false} strokeWidth={4} strokeColor="#515151" trailColor="#C8C8C8" />
          </Col>
        </Row>
      }
    />
  );
};
